import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const StickyCTA = ({ onOpenForm }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past hero (about 600px)
      setIsVisible(window.scrollY > 600);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      const ctaBtn = document.querySelector('[data-testid="explore-csr-btn"]');
      if (ctaBtn) ctaBtn.click();
    }, 500);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#E5E7EB] shadow-sm transition-all duration-300"
      data-testid="sticky-cta"
    >
      <div className="container mx-auto px-4 py-2.5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="https://customer-assets.emergentagent.com/job_fa466eb8-6701-4b93-b151-474047be8b48/artifacts/8el55r9b_Untitled-1%20%282%29.png"
            alt="CLiC"
            className="h-8 w-auto"
          />
          <span className="hidden sm:inline text-sm text-[#4A4A4A]">CSR Partnership</span>
        </div>
        
        <Button
          onClick={handleClick}
          className="bg-[#1F7A5A] hover:bg-[#145A43] text-white text-sm font-medium h-9 px-4"
          data-testid="sticky-cta-btn"
        >
          Start CSR Conversation
          <ArrowRight className="w-4 h-4 ml-1.5" />
        </Button>
      </div>
    </div>
  );
};

export default StickyCTA;
